// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"2496b421","123":"99f49072","310":"2496b421","594":"2496b421","702":"001fb384","730":"d94cbea4","748":"001fb384","862":"a634c6fd","880":"2496b421","969":"65fe443f","985":"99f49072","995":"90a10584"}[chunkId] + ".chunk.css";
};